import utilsService from '../../services/utilsService';
import homeService from '../../services/homeService';
import axios from 'axios';

// initial state
const state = {
  miniBudget:0,
  maxBudget:1500,
  miniDistance:5,
  maxDistance:40,
  miniBedrooms:1,
  maxBedrooms:5,
  selectedResults: [],
  includeSchool:0,
  includeRestaurant:0,
  includeTrainStation:0,
  includeBusStation:0,
  searchAsChange:false,
  hot:false,
  serviced:false,
  pet:false,
  new:false,
  query:{
    budget:'',
    walkDistance: '',
    bedroom:'',
    sort:'latest'
  },
  sortOption:[
    {
      label:'Most Recent',
      value:'latest'
    },
    {
      label:'Price (Low - High)',
      value:'price_asc'
    },
    {
      label:'Price (High - Low)',
      value:'price_desc'
    },
    {
      label:'Size (Low - High)',
      value:'size_asc'
    },
    {
      label:'Size (High - Low)',
      value:'size_desc'
    }
  ]
}

// getters
const getters = {
  get_query(state){
    const query = _.omit(state.query,['lat','lng'])
    return query
  },
}

// actions
const actions = {
  searchByType(context,params){
      return new Promise((resolve,reject)=>{
        homeService.searchByType(params)
        .then((resp) => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
  },
  defaultSearch(context, params){
      return new Promise((resolve, reject) => {
        homeService.defaultSearch()
        .then((resp) => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
  },
  search(context, params){
      return new Promise((resolve, reject) => {
          homeService.search(params)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
  }
}

// mutations
const mutations = {
  set_query(state,response) {
      localStorage.setItem('query', JSON.stringify(response))
      const result = utilsService.formatSearchQuery(response)
      state.query.station = result.station
      state.query.city = result.city
      state.query.trainLine = result.trainLine
      state.query.area = result.area
  },
  set_map_query(state, response) {
      state.query.lat = response.lat
      state.query.lng = response.lng
      state.query.zoom = response.zoom
  },
  set_reset(state, response){
      state.query = {
        budget:'',
        walkDistance: '',
        bedroom:'',
        sort:'latest',
        ...utilsService.formatSearchQuery(state.selectedResults)
      };
      state.security = false
      state.concierge = false
      state.pet = false
      state.parking = false
      state.balcony = false
      state.yard = false
      state.heating = false
      state.dishwasher = false
      state.dryer = false
      state.refrigerator = false

  },
  set_selected_results(state,response){
      state.selectedResults = response
  },
  set_include_school(state,response){
      state.includeSchool = response
  },
  set_include_restaurant(state, response){
      state.includeRestaurant = response
  },
  set_include_train_station(state, response){
      state.includeTrainStation = response
  },
  set_include_bus_station(state, response){
    state.includeBusStation = response
  },
  set_move_as_change(state, response) {
    state.searchAsChange = response
  },
  set_budget(state, response){
    state.query.budget =response
  },
  set_bedroom(state, response){
    state.query.bedroom = response
  },
  set_distance(state, response){
    state.query.walkDistance = response
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}